import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { CustomerGroup, CustomerGroup_$reflection } from "../Shared/ApiDataTypes.js";
import { obj_type, union_type, record_type, option_type, string_type, bool_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { unwrap, some, map, orElse, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { Company_fetchCompanies } from "../Promises.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Switch, TableContainer, TableBody, IconButton, Link, TableHead, TableRow, Table, TableCell, DialogActions, Button, DialogContent, Typography, MenuItem, TextField, DialogTitle, Dialog, Checkbox, FormControlLabel } from "@mui/material";
import { comparePrimitives, uncurry2, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { sortBy, map as map_1, tryFind } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { SnackError, wrapTooltip, errorBanner, loadingIndicatorSmall } from "../ViewHelpers.js";
import { cons, empty as empty_1, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { corsProps } from "../Promises.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { RouterModule_encodeQueryStringInts, RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import CheckCircle from "@mui/icons-material/CheckCircle";
import RemoveCircle from "@mui/icons-material/RemoveCircle";
import Edit from "@mui/icons-material/Edit";
import { Message as Message_1, dispatchContext } from "../CompanyHierarchyContext.js";
import { Components_Searchbar_25F45B5E } from "../Components/Searchbar.js";
import { Components_Button_Z1043B8E } from "../Components/Button.js";
import Add from "@mui/icons-material/Add";

class Model extends Record {
    constructor(Groups, AddForm, ShowDisabled, Filter, EditForm, ErrorMsg) {
        super();
        this.Groups = Groups;
        this.AddForm = AddForm;
        this.ShowDisabled = ShowDisabled;
        this.Filter = Filter;
        this.EditForm = EditForm;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Kundeweb.Admin.CustomerGroup.Model", [], Model, () => [["Groups", array_type(CustomerGroup_$reflection())], ["AddForm", bool_type], ["ShowDisabled", bool_type], ["Filter", string_type], ["EditForm", option_type(CustomerGroup_$reflection())], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ToggleAdd", "ToggleEdit", "SetShowDisabled", "SetFilter", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Kundeweb.Admin.CustomerGroup.Message", [], Message, () => [[["Item", bool_type]], [["Item", option_type(CustomerGroup_$reflection())]], [["Item", bool_type]], [["Item", string_type]], []]);
}

const init = new Model([], false, false, "", undefined, undefined);

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.Groups, model.AddForm, model.ShowDisabled, model.Filter, msg.fields[0], model.ErrorMsg);
        case 2:
            return new Model(model.Groups, model.AddForm, msg.fields[0], model.Filter, model.EditForm, model.ErrorMsg);
        case 3:
            return new Model(model.Groups, model.AddForm, model.ShowDisabled, msg.fields[0], model.EditForm, model.ErrorMsg);
        case 4:
            return new Model(model.Groups, model.AddForm, model.ShowDisabled, model.Filter, model.EditForm, undefined);
        default:
            return new Model(model.Groups, msg.fields[0], model.ShowDisabled, model.Filter, model.EditForm, model.ErrorMsg);
    }
}

function AddForm(addFormInputProps) {
    let elements_2, children, elems_1, children_1;
    const onClose = addFormInputProps.onClose;
    const updating = addFormInputProps.updating;
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const initial = defaultArg(updating, new CustomerGroup(-1, "", true, false, false, undefined));
    patternInput = reactApi.useState(initial);
    const setFormGroup = patternInput[1];
    const formGroup = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const setProcessing = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setErrMsg = patternInput_2[1];
    const patternInput_3 = reactApi.useState(undefined);
    useEffectOnce(() => {
        const pr = Company_fetchCompanies();
        pr.then((res) => {
            if (res.tag === 0) {
                patternInput_3[1](res.fields[0]);
            }
        });
    });
    const genericCheckbox = (value_1, label, onChange) => MuiHelpers_createElement(FormControlLabel, [["labelPlacement", "end"], ["label", label], ["control", MuiHelpers_createElement(Checkbox, [["checked", value_1], ["onChange", (e) => {
        onChange(e.target.checked);
    }], ["color", "primary"], ["id", `checkbox-${label}`]])]]);
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_7, v) => {
        onClose(undefined);
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", (updating != null) ? ctx.Locale.t("GroupAdmin.Update") : ctx.Locale.t("GroupAdmin.Update")]]), (children = singleton_1(createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        maxWidth: 500,
    }], (elems_1 = toList(delay(() => append(singleton(MuiHelpers_createElement(TextField, [["defaultValue", formGroup.Name], ["onChange", (e_2) => {
        setFormGroup(new CustomerGroup(formGroup.Id, e_2.target.value, formGroup.Enabled, formGroup.IsMain, formGroup.IsPtg, formGroup.Company));
    }], ["variant", "outlined"], ["label", ctx.Locale.t("Customer.Name")], ["fullWidth", true], ["style", {
        marginBottom: 5,
        marginTop: 5,
    }]])), delay(() => {
        let matchValue_2, d_17, elems;
        return append((matchValue_2 = patternInput_3[0], (matchValue_2 != null) ? ((d_17 = matchValue_2, singleton(MuiHelpers_createElement(TextField, [["label", ctx.Locale.t("Company")], ["select", true], ["value", orElse(map((a_3) => a_3.Id, formGroup.Company), -1)], ["onChange", (ev) => {
            const x_4 = ev.target.value | 0;
            setFormGroup(new CustomerGroup(formGroup.Id, formGroup.Name, formGroup.Enabled, formGroup.IsMain, formGroup.IsPtg, tryFind((y_2) => (y_2.Id === x_4), d_17)));
        }], (elems = [MuiHelpers_createElement(MenuItem, [["value", -1], ["children", "<N/A>"]]), map_1((x_5) => MuiHelpers_createElement(MenuItem, [["value", x_5.Id], ["children", x_5.Name]]), d_17)], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : singleton(loadingIndicatorSmall())), delay(() => append(singleton(genericCheckbox(formGroup.IsPtg, "PTG*", (x_6) => {
            setFormGroup(new CustomerGroup(formGroup.Id, formGroup.Name, formGroup.Enabled, formGroup.IsMain, x_6, formGroup.Company));
        })), delay(() => append(singleton(MuiHelpers_createElement(Typography, [["children", `*${ctx.Locale.t("GroupAdmin.Access")}`], ["sx", {
            fontStyle: "italic",
        }]])), delay(() => append((updating != null) ? singleton(genericCheckbox(formGroup.Enabled, ctx.Locale.t("Active"), (x_7) => {
            setFormGroup(new CustomerGroup(formGroup.Id, formGroup.Name, x_7, formGroup.IsMain, formGroup.IsPtg, formGroup.Company));
        })) : empty(), delay(() => singleton(errorBanner(patternInput_2[0], () => {
            setErrMsg(undefined);
        }))))))))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = toList(delay(() => (patternInput_1[0] ? singleton(loadingIndicatorSmall()) : append(singleton(MuiHelpers_createElement(Button, [["size", "small"], ["color", "primary"], ["variant", "outlined"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_9) => {
        onClose(undefined);
    }]])), delay(() => singleton(MuiHelpers_createElement(Button, [["size", "small"], ["color", "primary"], ["variant", "contained"], ["disabled", formGroup.Name.trim().length === 0], ["children", (updating != null) ? ctx.Locale.t("Update") : ctx.Locale.t("Add")], ["onClick", (_arg_10) => {
        const pr_3 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let data, decoder, data_1, caseStrategy_3, extra_3, body_2, decoder_3, data_5, caseStrategy_12, extra_12;
            if (formGroup.Name.trim().length > 0) {
                setProcessing(true);
                return ((updating != null) ? ((data = some(Auto_generateBoxedEncoder_437914C6(CustomerGroup_$reflection(), undefined, undefined, undefined)(formGroup)), (decoder = Auto_generateBoxedDecoder_Z6670B51(CustomerGroup_$reflection(), undefined, undefined), (data_1 = data, (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                    let properties_2;
                    try {
                        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                        const pr_1 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/customer-group", properties_3).then((_arg_1) => {
                            let response_1, decoder_1_1;
                            return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(CustomerGroup_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_2) => {
                                let matchValue;
                                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                        }))));
                        return pr_1.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                    }
                    catch (exn) {
                        return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                    }
                })())))))) : ((body_2 = Auto_generateBoxedEncoder_437914C6(CustomerGroup_$reflection(), undefined, undefined, undefined)(formGroup), (decoder_3 = Auto_generateBoxedDecoder_Z6670B51(CustomerGroup_$reflection(), undefined, undefined), (data_5 = some(body_2), (caseStrategy_12 = undefined, (extra_12 = undefined, (() => {
                    let properties_6;
                    try {
                        const properties_3_1 = Helper_withProperties(corsProps, (properties_6 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty_1()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_12), unwrap(extra_12))(data_1_2))]), properties_6), data_5), properties_6)));
                        const pr_2 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/customer-group", properties_3_1).then((_arg_3) => {
                            let response_3, decoder_1_2;
                            return ((response_3 = _arg_3, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(CustomerGroup_$reflection(), unwrap(caseStrategy_12), unwrap(extra_12))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_3.text().then((_arg_4) => {
                                let matchValue_1;
                                return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_2), _arg_4), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
                        }))));
                        return pr_2.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])]))));
                    }
                    catch (exn_1) {
                        return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
                    }
                })()))))))).then((_arg_5) => {
                    const res_1 = _arg_5;
                    if (res_1.tag === 1) {
                        const e_1 = res_1.fields[0];
                        setErrMsg((e_1.tag === 2) ? (((e_1.fields[0].status) === 409) ? ctx.Locale.t("GroupAdmin.NameTaken") : ctx.Locale.t("GroupAdmin.AddFailed")) : ctx.Locale.t("GroupAdmin.AddFailed"));
                        setProcessing(false);
                        return Promise.resolve();
                    }
                    else {
                        onClose(res_1.fields[0]);
                        return Promise.resolve();
                    }
                });
            }
            else {
                return Promise.resolve();
            }
        }));
        pr_3.then();
    }]]))))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

function groupTable(locale, entries, dispatch, showDisabled) {
    let elements_5, children_3, children_2, children_7;
    const th$0027 = (txt) => MuiHelpers_createElement(TableCell, [["style", {}], ["variant", "head"], ["children", txt]]);
    const children_8 = singleton_1(MuiHelpers_createElement(Table, [["size", "small"], (elements_5 = [(children_3 = singleton_1((children_2 = toList(delay(() => append(singleton(th$0027(locale.t("Customer.Name"))), delay(() => append(singleton(th$0027(locale.t("Company"))), delay(() => append(singleton(th$0027("PTG")), delay(() => append(showDisabled ? singleton(MuiHelpers_createElement(TableCell, [["style", {
        textAlign: "center",
    }], ["variant", "head"], ["children", locale.t("Active")]])) : empty(), delay(() => singleton(th$0027("")))))))))))), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_2))]]))), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_3))]])), (children_7 = map_1((x_4) => {
        let elems_8;
        return MuiHelpers_createElement(TableRow, [(elems_8 = toList(delay(() => {
            let elems_3;
            return append(singleton(MuiHelpers_createElement(TableCell, [(elems_3 = [MuiHelpers_createElement(Link, [["href", RouterModule_encodeParts(ofArray(["admin", "customer-groups", "customers" + RouterModule_encodeQueryStringInts(singleton_1(["groups", x_4.Id]))]), 1)], ["children", x_4.Name]])], ["children", reactApi.Children.toArray(Array.from(elems_3))])])), delay(() => {
                let children_4, matchValue;
                return append(singleton((children_4 = singleton_1(MuiHelpers_createElement(Typography, [["children", (matchValue = x_4.Company, (matchValue != null) ? matchValue.Name : "")]])), MuiHelpers_createElement(TableCell, [["children", reactApi.Children.toArray(Array.from(children_4))]]))), delay(() => {
                    let children_5;
                    return append(singleton((children_5 = singleton_1(MuiHelpers_createElement(Typography, [["children", x_4.IsPtg ? locale.t("Yes") : locale.t("No")]])), MuiHelpers_createElement(TableCell, [["children", reactApi.Children.toArray(Array.from(children_5))]]))), delay(() => {
                        let elems;
                        return append(showDisabled ? singleton(MuiHelpers_createElement(TableCell, [["style", {
                            color: "hsl(207.3, 30%, 28%)",
                            textAlign: "center",
                        }], (elems = toList(delay(() => {
                            let props_1, props_3;
                            return x_4.Enabled ? singleton((props_1 = {}, react.createElement(CheckCircle, props_1))) : singleton((props_3 = {}, react.createElement(RemoveCircle, props_3)));
                        })), ["children", reactApi.Children.toArray(Array.from(elems))])])) : empty(), delay(() => {
                            let elems_7, child, elems_6, props_11;
                            return singleton(MuiHelpers_createElement(TableCell, [["style", {
                                color: "hsl(207.3, 30.8%, 21%)",
                                textAlign: "right",
                            }], (elems_7 = [(child = MuiHelpers_createElement(IconButton, [["style", {
                                color: "hsl(207.3, 30.8%, 21%)",
                            }], ["onClick", (_arg) => {
                                dispatch(new Message(1, [x_4]));
                            }], (elems_6 = [(props_11 = {}, react.createElement(Edit, props_11))], ["children", reactApi.Children.toArray(Array.from(elems_6))])]), wrapTooltip(locale.t("Edit"), child))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]));
                        }));
                    }));
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_8))])]);
    }, sortBy((x_2) => x_2.Name, (showDisabled ? ((x) => x) : ((array) => array.filter((x_1) => x_1.Enabled)))(entries), {
        Compare: comparePrimitives,
    })), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_7))]]))], ["children", reactApi.Children.toArray(Array.from(elements_5))])]));
    return MuiHelpers_createElement(TableContainer, [["children", reactApi.Children.toArray(Array.from(children_8))]]);
}

export function CustomerGroupAdmin(customerGroupAdminInputProps) {
    let groups_1, x;
    const groups = customerGroupAdminInputProps.groups;
    const ctx = reactApi.useContext(ctx_1);
    const hierarchyDispatch = reactApi.useContext(dispatchContext);
    let patternInput;
    const arg_1 = new Model(groups, init.AddForm, init.ShowDisabled, init.Filter, init.EditForm, init.ErrorMsg);
    patternInput = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const sorted = sortBy((x_1) => !x_1.Enabled, (groups_1 = groups, (model_1.Filter.length === 0) ? groups_1 : ((x = groups_1.filter((y) => (y.Name.toLocaleLowerCase().indexOf(model_1.Filter.toLocaleLowerCase()) >= 0)), model_1.ShowDisabled ? x : x.filter((y_1) => y_1.Enabled)))), {
        Compare: comparePrimitives,
    });
    const xs_3 = toList(delay(() => append(singleton(createElement(SnackError, {
        errMsg: unwrap(model_1.ErrorMsg),
        dismiss: () => {
            dispatch(new Message(4, []));
        },
    })), delay(() => append(model_1.AddForm ? singleton(createElement(AddForm, {
        onClose: (newGroup) => {
            if (newGroup != null) {
                hierarchyDispatch(new Message_1(1, [newGroup]));
            }
            dispatch(new Message(0, [false]));
        },
    })) : empty(), delay(() => {
        let matchValue, x_3;
        return append((matchValue = model_1.EditForm, (matchValue != null) ? ((x_3 = matchValue, singleton(createElement(AddForm, {
            updating: x_3,
            onClose: (updated) => {
                if (updated != null) {
                    hierarchyDispatch(new Message_1(11, [updated]));
                }
                dispatch(new Message(1, [undefined]));
            },
        })))) : (empty())), delay(() => {
            let elems_2, elems_1, elems;
            return append(singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexWrap: "wrap",
                width: 100 + "%",
            }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                flexGrow: 1,
            }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
                flexBasis: 320 + "px",
            }], (elems = [createElement(Components_Searchbar_25F45B5E, {
                placeholder: ctx.Locale.t("Search"),
                onChange: (ev) => dispatch(new Message(3, [ev.target.value])),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), MuiHelpers_createElement(FormControlLabel, [["labelPlacement", "start"], ["label", ctx.Locale.t("UserAdmin.ShowInactive")], ["control", MuiHelpers_createElement(Switch, [["color", "primary"], ["checked", model_1.ShowDisabled], ["onChange", (e) => {
                dispatch(new Message(2, [e.target.checked]));
            }]])]])], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(Components_Button_Z1043B8E, {
                text: ctx.Locale.t("GroupAdmin.Add"),
                onClick: (_arg_1) => {
                    dispatch(new Message(0, [!model_1.AddForm]));
                },
                startIcon: (props_4) => {
                    const props_6 = createObj(props_4);
                    return react.createElement(Add, props_6);
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => singleton(groupTable(ctx.Locale, sorted, dispatch, model_1.ShowDisabled))));
        }));
    }))))));
    return react.createElement(react.Fragment, {}, ...xs_3);
}

